











import "@szgc/plt-ui-v2/libs/pltui.css";
import { Vue, Component, Prop } from "vue-property-decorator";
import AppButton from "../AppButton/index.vue";
import { PltSelect } from "@szgc/plt-ui-v2";

@Component({
  name: "SelectComponent",
  components: { AppButton, PltSelect }
})
export default class SelectComponent extends Vue {
  @Prop({ required: true })
  value!: string;

  @Prop({ required: true })
  text!: string;

  @Prop({ default: () => [] })
  params!: any;

  @Prop({ required: true, default: false })
  show!: boolean;

  @Prop({ default: false })
  multi!: boolean;

  @Prop({ required: true })
  limiter!: string;

  @Prop({ default: "" })
  select!: string;

  @Prop({ required: true })
  type!: string;

  get showPltSelect() {
    return this.show;
  }

  set showPltSelect(n) {
    this.$emit("update:show", n);
  }

  selectModalEvt(data: any) {
    this.$emit("update:value", data.valueText);
    this.$emit("update:text", data.text);
    this.$emit("confirm", data);
  }
}
